import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import { ContractInDto } from 'shared/dtos/in/contract';
import { broadcastUploadedContractError } from 'serviceWorker/broadcasts/contract/error';
import {
  broadcastCreatedContract,
  broadcastDeletedContract,
  broadcastUpdatedContract,
  broadcastUploadedContract,
} from 'serviceWorker/broadcasts/contract/one';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { neverReached } from 'shared/utils/neverReached';
import { projectIdOfRequest } from 'serviceWorker/helpers/dataScope';

export function broadcastContractResponse(
  request: HttpRequestEntity,
  response: ContractInDto | any
): void {
  const { uniqueId } = request.data;
  if (response.error) {
    return broadcastUploadedContractError(response.error, chooseErrorMessage(response.error), uniqueId);
  }
  switch (request.method) {
    case 'POST':
      // Never rejects: a failure is broadcast as `failUploadedEntity` with the `uniqueId`.
      return void broadcastCreatedContract(response, uniqueId, projectIdOfRequest(request));
    // A restore is queued as GET; its runner answers `true`.
    case 'GET':
      return broadcastUploadedContract(response, uniqueId);
    case 'PUT':
      return broadcastUpdatedContract(response, uniqueId);
    case 'DELETE':
      return broadcastDeletedContract(response, uniqueId);
    default:
      neverReached(request.method);
  }
}

/** Carries the change's `uniqueId`, so the page's command rejects with this error. */
export function broadcastContractError(
  request: HttpRequestEntity,
  error: unknown,
  uniqueId?: string
): void {
  broadcastUploadedContractError(error, chooseErrorMessage(error), uniqueId ?? request.data?.uniqueId);
}
